import { ExperimentState } from 'modules/graphql';

export enum CELL_DISPLAY_TYPE {
  NA = 'NA',
  COLORIZED_METRICS = 'COLORIZED_METRICS',
  DEFAULT = 'DEFAULT',
}

export const getCellDisplayType = (state: ExperimentState, hasWinner: boolean) => {
  if (state === ExperimentState.DRAFT || state === ExperimentState.READY) {
    return CELL_DISPLAY_TYPE.NA;
  } else if (
    // If experiment is Finished but has no selected winner,
    // Don't colorize metrics
    (state === ExperimentState.FINISHED ||
      state === ExperimentState.USER_SELECTED_WINNER ||
      state === ExperimentState.WINNER_FOUND) &&
    hasWinner
  ) {
    return CELL_DISPLAY_TYPE.COLORIZED_METRICS;
  } else {
    return CELL_DISPLAY_TYPE.DEFAULT;
  }
};
